import React from 'react';
import './RehashNotPossibleModal.scss';

import { modalOverlayBackgroundColor } from 'util/constants';
import GenericModal from 'components/GenericModal';
import ReasonsBox from './ReasonsBox';

interface RehashNotPossibleModalProps {
  isOpen: boolean;
  reasons: string[];
  keepOriginalOffers: () => void;
  refreshOffers: () => void;
}

const RehashNotPossibleModal = ({
  isOpen,
  reasons,
  keepOriginalOffers,
  refreshOffers,
}: RehashNotPossibleModalProps) => {
  const customStyles = {
    overlay: {
      backgroundColor: modalOverlayBackgroundColor,
    },
    content: {
      maxWidth: '600px',
    },
  };

  return (
    <GenericModal
      isOpen={isOpen}
      contentLabel="Rehash Not Possible Modal"
      style={customStyles}
      title="Deal structure has been updated by the customer"
      actions={{
        primary: {
          label: 'Resubmit for new Upstart offer',
          color: 'error',
          onClick: () => refreshOffers(),
        },
        secondary: {
          label: 'Keep original offer',
          onClick: () => keepOriginalOffers(),
        },
      }}
    >
      <div className="rehash-not-possible-details">
        <div className="rehash-not-possible-details__text">
          The customer selected a deal structure that conflicts with an existing
          offer.
        </div>

        <ReasonsBox reasons={reasons} />

        <div className="rehash-not-possible-details__text">
          To match the new deal structure, you need to resubmit the credit
          application to generate a new Upstart offer.
          <br />
          <br />
          <span className="rehash-not-possible-details__notice">
            All existing offers will be removed, this cannot be undone!
          </span>
        </div>
      </div>
    </GenericModal>
  );
};

export default RehashNotPossibleModal;
